// 新浪表情包api https://api.weibo.com/2/emotions.json?source=1362404091
export const sina = [
    {
        alt: "[坏笑]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/4d/2018new_huaixiao_org.png"
    },
    {
        alt: "[笑cry]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/4a/2018new_xiaoku_org.png"
    },
    {
        alt: "[拜拜]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/fd/2018new_baibai_org.png"
    },
    {
        alt: "[微笑]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/e3/2018new_weixioa02_org.png"
    },
    {
        alt: "[偷笑]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/71/2018new_touxiao_org.png"
    },
    {
        alt: "[亲亲]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/2c/2018new_qinqin_org.png"
    },
    {
        alt: "[太开心]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/1e/2018new_taikaixin_org.png"
    },
    {
        alt: "[挤眼]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/43/2018new_jiyan_org.png"
    },
    {
        alt: "[可怜]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/96/2018new_kelian_org.png"
    },
    {
        alt: "[可爱]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/09/2018new_keai_org.png"
    },
    {
        alt: "[doge]",
        src: "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/a1/2018new_doge02_org.png"
    },
    {
        alt: "[二哈]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/22/2018new_erha_org.png"
    },
    {
        alt: "[喵喵]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/7b/2018new_miaomiao_org.png"
    },
    {
        alt: "[摊手]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/62/2018new_tanshou_org.png"
    },
    {
        alt: "[跪了]",
        src:
            "http://img.t.sinajs.cn/t4/appstyle/expression/ext/normal/75/2018new_gui_org.png"
    }
]